import { useEffect, useState } from "react";
import { GrowthChart } from "components/charts";
import { ChartLayout } from "layouts";
import { Spinner } from "components";

function Growth({ growthData, setDateRange }) {
  const { categories = [], data = [], loading, error } = growthData;
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    if (loading) {
      setFadeIn(false);
    } else {
      const timer = setTimeout(() => {
        setFadeIn(true);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [loading]);

  return (
    <ChartLayout title="Growth" setDate={setDateRange}>
      {loading ? (
        <div className="flex flex-col items-center justify-center h-full p-4 transition-opacity duration-300 ease-in-out">
          <Spinner size="large" color="#19a8a6" />
        </div>
      ) : error ? (
        <div className="flex items-center justify-center h-full transition-opacity duration-300 ease-in-out">
          <div className="text-red-500">Error loading growth data</div>
        </div>
      ) : (
        <div
          className={`w-full flex-1 flex flex-col py-4 transition-opacity duration-300 ease-in-out ${
            fadeIn ? "opacity-100" : "opacity-0"
          }`}
        >
          <GrowthChart
            series={data}
            labels={categories}
            key={`growth-container-${JSON.stringify(
              categories
            )}-${JSON.stringify(data)}`}
          />
        </div>
      )}
    </ChartLayout>
  );
}

export default Growth;
